import * as React from "react";
import { TActState, getSettingStatus, } from "../../../../services/product";
import TimeReduce from "../../../../components/DiscountTime";
import { TagOutside, TagInside } from "./styles";
import throttle from "../../../../utils/throttle";
export default function FlashProductsTag(props) {
    var _a;
    const { tagGroup, stickToTop = 0 } = props;
    const [activeTab, changeActiveTab] = React.useState(props.activeTab);
    const [isFixed, setTabPostition] = React.useState(false);
    React.useEffect(() => {
        changeActiveTab(props.activeTab);
        if (props.canScrollFixed) {
            window.addEventListener("scroll", throttle(onScroll, 30));
        }
        return () => {
            window.removeEventListener("scroll", onScroll);
        };
    }, [props.activeTab]);
    const tabClick = (item, index) => {
        changeActiveTab(item.id);
        if (item.id !== props.activeTab) {
            props.onChange(item.id, index, isFixed);
        }
        const { clientElement } = props;
        if (!clientElement) {
            return;
        }
        const currentElementRect = clientElement === null || clientElement === void 0 ? void 0 : clientElement.getBoundingClientRect();
        const scrollTop = window.scrollY || window.pageYOffset;
        const condition = scrollTop > (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) - props.stickToTop &&
            scrollTop < (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) + (currentElementRect === null || currentElementRect === void 0 ? void 0 : currentElementRect.height);
        if (isFixed && condition) {
            window.scrollTo(0, Math.max(0, (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) - props.stickToTop));
        }
    };
    const onScroll = (event) => {
        var _a;
        const target = event.target;
        const scrollTop = ((_a = target === null || target === void 0 ? void 0 : target.documentElement) === null || _a === void 0 ? void 0 : _a.scrollTop) || window.scrollY || window.pageYOffset;
        const { clientElement } = props;
        if (!clientElement) {
            return;
        }
        const currentElementRect = clientElement === null || clientElement === void 0 ? void 0 : clientElement.getBoundingClientRect();
        const condition = scrollTop >= (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) - props.stickToTop &&
            scrollTop < (clientElement === null || clientElement === void 0 ? void 0 : clientElement.offsetTop) + (currentElementRect === null || currentElementRect === void 0 ? void 0 : currentElementRect.height);
        if (condition) {
            setTabPostition(true);
        }
        else {
            setTabPostition(false);
        }
    };
    const nextActiveTab = activeTab || ((_a = props.tagGroup[0]) === null || _a === void 0 ? void 0 : _a.id) || "";
    return (React.createElement(TagOutside, null,
        React.createElement(TagInside, { isFixed: isFixed, style: {
                backgroundColor: "#fff",
            }, scrollTop: stickToTop },
            React.createElement("ul", { className: tagGroup.length <= 3 ? "averageTag" : "moreTag" }, tagGroup.map((item, index) => (React.createElement("li", { className: nextActiveTab === item.id ? "activeTab" : "", key: index, onClick: () => tabClick(item, index) },
                React.createElement("p", null, item.name),
                getSettingStatus(item.state),
                item.state === TActState.OnGoing && (React.createElement(TimeReduce, { time: parseInt(item.endSpan, 10) })))))))));
}
